import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import AboutPage from '../views/AboutPage.vue';
import ContactPage from '../views/ContactPage.vue';
import PartnersPage from '../views/PartnersPage.vue';
import SeasonParkingPage from '../views/SeasonParkingPage.vue';
import ParkingCouponsPage from '../views/ParkingCouponsPage.vue';
import FindBPSBoothPage from '../views/FindBPSBoothPage.vue';
import SearchParkingOffencePage from '../views/SearchParkingOffencePage.vue';
import NewsPage from '../views/NewsPage.vue';
import ParkingLotsPage from '../views/ParkingLotsPage.vue';
import OnlinePaymentGuidePage from '../views/OnlinePaymentGuidePage.vue';


const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage,
  },
  {
    path: '/partners',
    name: 'PartnersPage',
    component: PartnersPage,
  },
  {
    path: '/season-parking',
    name: 'SeasonParkingPage',
    component: SeasonParkingPage,
  },
  {
    path: '/parking-coupons',
    name: 'ParkingCouponsPage',
    component: ParkingCouponsPage,
  },
  {
    path: '/find-bps-booth',
    name: 'FindBPSBoothPage',
    component: FindBPSBoothPage,
  },
  {
    path: '/search-parking-offence',
    name: 'SearchParkingOffencePage',
    component: SearchParkingOffencePage,
  },
  {
    path: '/news',
    name: 'NewsPage',
    component: NewsPage,
  },
  {
    path: '/parking-lots',
    name: 'ParkingLotsPage',
    component: ParkingLotsPage,
  },
  {
    path: '/online-payment-guide',
    name: 'OnlinePaymentGuidePage',
    component: OnlinePaymentGuidePage,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;